import { render, staticRenderFns } from "./arbitrage-transaction-details.vue?vue&type=template&id=7936dd3d&scoped=true&"
import script from "./arbitrage-transaction-details.vue?vue&type=script&lang=js&"
export * from "./arbitrage-transaction-details.vue?vue&type=script&lang=js&"
import style0 from "./arbitrage-transaction-details.vue?vue&type=style&index=0&id=7936dd3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7936dd3d",
  null
  
)

export default component.exports